angular.module('unica_user.user_controllers')

.controller('UserEditController', function(
	$rootScope, $scope, $state, $stateParams,
	UserListService, UserEditService
) {

	$scope.passwordRequired = false;

	$rootScope.getUser( $stateParams.id );

	$scope.passwordChanged = function() {
		if ( $rootScope.userData.password !== '' ) {
			$scope.passwordRequired = true;
		} else {
			$scope.passwordRequired = false;
		}
	};

	$scope.removeAvatarImage = function() {
		$rootScope.userData.avatar = null;
		$rootScope.userData.avatar_change = 1;
		// $rootScope.userData.avatar.dataURL = '';
	};

	$scope.saveUser = function() {
		$scope.showLoader();

		$rootScope.userData.edit = true;

		var userData = angular.copy($rootScope.userData);

		if ( userData.avatar && userData.avatar.dataURL ) {
			userData.avatar = userData.avatar.dataURL;
		}

		UserEditService
			.update(userData, 1)
			.then(function(user) {
				$scope.hideLoader();

				if ( user ) {
					$scope.showSuccessMsg('Utente aggiornato con successo!', '');

					if ( user.role === 'admin' || user.role === 'service' || user.role === 'report_manager' || user.role === 'cons_welfare' ) {
						$state.go('app.user.list');
					} else {
						$state.go('app.user.edit_second_step', { id : user.id });
					}
				}

			});

	};

})


.controller('UserEditSecondStepController', function(
	$rootScope, $scope, $state, $stateParams,
	UserEditService
) {

	$scope.user_id = $stateParams.id;

	$rootScope.getUser( $stateParams.id );

	$scope.$on('user_loaded', function() {

		$scope.checkParent();
		$scope.loadNets();
		$scope.loadStructures();
		$scope.loadZones();
		$scope.loadProvinces();

	});

	$scope.saveUser = function() {
		$scope.showLoader();

		UserEditService
			.update( $rootScope.userData, 2 )
			.then(function(user) {
				$scope.hideLoader();

				if ( user ) {
					$scope.showSuccessMsg('Utente aggiornato con successo!', '');

					if ( user.role === 'agency' ) {
						$state.go('app.user.list');
					} else {
						$state.go('app.user.edit_third_step', { id : user.id });
					}
				}

			});
	};

})


.controller('UserEditThirdStepController', function(
	$rootScope, $scope, $state, $stateParams,
	UserEditService
) {

	$scope.user_id = $stateParams.id;

	$rootScope.getUser( $stateParams.id );

	$scope.saveUser = function() {
		$scope.showLoader();

		UserEditService
			.update( $rootScope.userData, 3 )
			.then(function(user) {
				$scope.hideLoader();

				if ( user ) {
					$scope.showSuccessMsg('Utente aggiornato con successo!', '');
					$state.go('app.user.list');
				}

			});
	};

})



;